// http://react-component.github.io/badgeboard/
// http://react-component.github.io/slider/

import React from 'react';
import Slider, {Range} from 'rc-slider';
// We can just import Slider or Range to reduce bundle size
// import Slider from 'rc-slider/lib/Slider';
// import Range from 'rc-slider/lib/Range';
import * as PropTypes from "prop-types";
import 'rc-slider/assets/index.css';
import '../../../assets/sass/components/slider.scss';

class SliderRange extends React.Component {

    static propTypes = {
        // set name for component
        name: PropTypes.string,
        // event change
        onSliderChange: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const from = this.props.from ?? this.props.min ?? 0;
        const to = this.props.to ?? this.props.max ?? 100;

        this.state = {
            value: [from, to],
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {from, to} = this.props;
        this.setState({
            value: [from, to]
        });
    }

    componentDidMount() {
        if (this.props.onLoad) {
            var {value} = this.state;
            var {name} = this.props;
            this.props.onLoad(name, value);
        }
    }

    componentWillUnmount() {
        if (this.props.onDestroy) {
            var {name} = this.props;
            this.props.onDestroy(name);
        }
    }

    onSliderChange = (value) => {
        var {name} = this.props;
        this.setState({
            value,
        });
        if (this.props.onSliderChange)
            this.props.onSliderChange(name, value);
    }
    // handleApply = () => {
    //     const { lowerBound, upperBound } = this.state;
    //     this.setState({ value: [lowerBound, upperBound] });
    // }
    render() {
        return (
            <div className="slider slider-range">
                <span>{this.state.value[0] >= 10 ? this.state.value[0] : `0${this.state.value[0]}`}</span>
                <div className="slider-wrapper">
                    <Range
                        {...this.props}
                        allowCross={false}
                        value={this.state.value}
                        onChange={this.onSliderChange}
                    />
                </div>
                <span>{this.state.value[1] >= 10 ? this.state.value[1] : `0${this.state.value[1]}`}</span>
            </div>
        );
    }
}


export default SliderRange;
